// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"467b9871","253":"72d05220","317":"467b9871","320":"c076dca3","518":"ec954fb8","541":"467b9871"}[chunkId] + ".chunk.css";
};